import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from './components/Toaster'
import App from './App'
import { applyCachedBrand } from './hooks/useBranding'
import 'maplibre-gl/dist/maplibre-gl.css'
import './index.css'

applyCachedBrand()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
      {/* Bottom centre: the top is every page's header, and the wizard's Back
          and Next sit in the bottom corners. Every toast can be closed. */}
      <Toaster
        position="bottom-center"
        richColors
        closeButton
        toastOptions={{
          classNames: {
            toast: 'sonner-toast',
            title: 'sonner-toast-title',
            description: 'sonner-toast-description',
          },
        }}
      />
    </BrowserRouter>
  </QueryClientProvider>,
)
